let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("f1x0y"), load("f2tqy")]).then(() => parcelRequire('kfwI9'));